export default __webpack_public_path__ + "static/media/Snd_TryB.ef89c753.mp3";